import {h} from 'preact';
import {route} from "preact-router"
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import {openPopup} from "../utils/popups";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as I from "../utils/icons"

export default function MenuBetServices() {
	return <div>
		<M.SecondarySportsMenuTitle>Bet Services</M.SecondarySportsMenuTitle>
		<M.BetServicesContent>
		  <M.BetServicesCell onClick={e => openPopup('https://s5.sir.sportradar.com/betinaction/en', 'livescore')}>
			<I.Stopwatch class="h-6" />
			<div><Trans>Live Score</Trans></div>
		  </M.BetServicesCell>
		  <M.BetServicesCell onClick={e => openPopup('https://statistics.betconstruct.com/#/en', 'results')}>
			<I.StatsIconSlim class="h-6" />
			<div><Trans>Results</Trans></div>
		  </M.BetServicesCell>
		  <M.BetServicesCell onClick={e => route("/print-odds")}>
			<I.PrinterIcon class="h-6" />
			<div><Trans>Print Odds</Trans></div>
		  </M.BetServicesCell>
		</M.BetServicesContent>
	</div>
}
